import useHover from "@/hooks/useHover";
import useOnClickOutside from "@/hooks/useOnClickOutside";
import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import styles from "./single-dropdown.module.scss";

export type SingleDropdownItem = {
  label: any;
  value: any;
  children?: SingleDropdownItem[];
};

export type SingleDropdownPropsType = {
  label: string;
  items: SingleDropdownItem[];
  onChange?: Function;
  showSelected?: boolean;
};

const SingleDropdown = ({
  label,
  items,
  onChange,
  showSelected = false,
}: SingleDropdownPropsType) => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [selectLabel, setSelectLabel] = useState(label);

  useHover(
    ref,
    () => setOpen(true),
    () => setOpen(false)
  );
  useOnClickOutside(ref, () => setOpen(false));

  useEffect(() => {
    setSelectLabel(label);
  }, [label]);

  const dropdownItemsTemplate = () => {
    const getTemplate = (item: SingleDropdownItem, isChildren = false): any => {
      return (
        <Fragment key={`${item.label}${item.value}`}>
          <li>
            <button
              role="button"
              aria-label="button"
              className={isChildren ? `ps-3 ${styles.child}` : ""}
              onClick={() => {
                setOpen(false);
                if (onChange) {
                  onChange(item.value);
                }
                if (showSelected) {
                  setSelectLabel(item.label);
                }
              }}
            >
              {item.label}
            </button>
          </li>
          {item.children?.length && (
            <>{item.children.map((v) => getTemplate(v, true))}</>
          )}
        </Fragment>
      );
    };
    return items.map((v) => getTemplate(v));
  };

  return (
    <div className={styles.select} ref={ref}>
      <ul>
        <li className="pointer" onClick={() => setOpen(!open)}>
          {selectLabel}
          {open ? (
            <i className="bi bi-caret-up-fill"></i>
          ) : (
            <i className="bi bi-caret-down-fill"></i>
          )}
        </li>

        <ul className={`${styles.dropdown} ${!open ? "d-none" : ""}`}>
          {dropdownItemsTemplate()}
          {items.length == 0 && (
            <li onClick={() => setOpen(false)}>
              <button role="button">No options</button>
            </li>
          )}
        </ul>
      </ul>
    </div>
  );
};

export default SingleDropdown;
